import { ActionTypeKeys } from 'embed/actions'
import { IToggle } from 'unleash-proxy-client'
import { actions as ExperimentActions } from 'embed/experiment/slice'
import { createExperimentToggle } from 'embed/experiment/types'

import { Unleash } from 'embed/experiment/unleash'
import { Session } from 'embed/services/Session'
import { ExperimentCohorts } from 'ui/multi-product/experiment'

function iToggleToExperimentToggle(toggle: IToggle) {
  return createExperimentToggle({
    enabled: !!toggle.enabled,
    featureName: toggle.name,
    variantName: toggle.variant.name,
  })
}

const unleashContextMiddleware =
  (unleashService: Unleash, sessionService: Session, cohorts: ExperimentCohorts = {}) =>
  (store) => {
    function byToggleWithCohort(toggle: IToggle) {
      const cohort = cohorts[toggle.name]
      return cohort !== undefined ? cohort.includes(sessionService.companyUuid) : true
    }

    function loadExperiments() {
      const experimentToggles = unleashService.getToggles().filter(byToggleWithCohort).map(iToggleToExperimentToggle)
      if (experimentToggles.length) {
        store.dispatch(ExperimentActions.upsertExperiments(experimentToggles))
      }
    }

    unleashService.on('init', loadExperiments)
    unleashService.on('update', loadExperiments)

    unleashService.updateContext({
      companyUuid: sessionService.companyUuid,
      leadUuid: sessionService.getLeadUuid(),
    })

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    unleashService.init()

    return (next) => (action) => {
      // run redux initialization first before this middleware fires
      const result = next(action)
      try {
        switch (action.type) {
          case ActionTypeKeys.FETCH_RATE_TABLES_SUCCESS:
            // At the time of writing, the leadUuid may change after fetching a rateTable
            const unleashContextLeadUuid = unleashService.getContext().sessionId
            const updatedLeadUuid = sessionService.getLeadUuid()
            if (updatedLeadUuid !== unleashContextLeadUuid) {
              unleashService.updateContext({ leadUuid: updatedLeadUuid })
            }
            break
          default:
        }
      } catch (err) {
        console.error('UNLEASH MIDDLEWARE ERROR', err)
      }

      return result
    }
  }

export default unleashContextMiddleware
